import merge from 'lodash/merge';
/**
   * A component that lists your options based on your input, using choices.js, Fuse and the webuniversum styling.
   * @displayName Autocomplete
   */
export default {
  data: () => ({
    choice: null
  }),

  computed: {
    config() {
      return merge(
        {
          searchResultLimit: this.searchResultLimit,
          placeholderValue: this.placeholder,
          itemSelectText: 'Selecteer',
          noResultsText: 'Geen items gevonden',
          classNames: {
            containerOuter: 'vl-pill-input',
            containerInner: 'vl-pill-input__inner vl-select',
            inputCloned: 'dwse-autocomplete-input'
          },
          sortFn: (a, b) => {
            if (a.label.trim() < b.label.trim()) { return -1; }
            if (a.label.trim() > b.label.trim()) { return 1; }
            return 0;
          },
          fuseOptions: {
            threshold: '0.5',
            minMatchCharLength: 2
          }
        },
        this.choicesOptions,
        { fuseOptions: this.fuseOptions }
      );
    },
    hasChoicesToClear() {
      const valueCheck = Array.isArray(this.value) ? this.value.length : this.value;
      return this.modClearChoices && valueCheck;
    }
  },

  props: {
    /**
     * [See options](#options)
     */
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Object],
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Typ om te zoeken...'
    },
    modClearChoices: Boolean,
    /**
     * [See Fuse Options](#fuse-options)
     */
    fuseOptions: {
      type: Object,
      default: () => ({})
    },
    /**
     * [See Choises Options](#choises-options)
     */
    choicesOptions: {
      type: Object,
      default: () => ({})
    },
    searchResultLimit: {
      type: Number,
      default: 1000
    }
  },

  watch: {
    options(opts) {
      this.setInitialSelectedValue(opts);
    },
    value(val) {
      if (!val) {
        this.setInitialChoice();
      } else if (val) {
        this.choice.setChoiceByValue(val);
      }
    }
  },

  mounted() {
    const Choices = require('choices.js');
    const inputEl = this.$refs['autocomplete'].$el;
    if (inputEl) {
      inputEl.value = this.value;
      this.choice = new Choices(inputEl, this.config);

      this.choice.passedElement.element.addEventListener('change', this.handleEvents, false);
      this.choice.passedElement.element.addEventListener('search', this.handleSearch, false);

      this.$nextTick(() => {
        this.setInitialSelectedValue();
      });
    }
  },

  methods: {
    handleEvents() {
      /**
       * Triggers when selecting an option.
       * @type {string}
       */
      this.$emit('selected', this.choice.getValue(true));
    },

    handleSearch({ detail: { value } }) {
      /**
       * Triggers when searching.
       * @type {string}
       */
      this.$emit('search', value);
    },

    setInitialChoice() {
      this.choice.setChoices([{ value: '', label: this.placeholder, selected: true, disabled: true, placeholder: true }, ...this.options], 'value', 'label', true);
      this.$emit('remove-choice', null);
    },

    setInitialSelectedValue(opts) {
      const options = opts || this.options;
      if (Array.isArray(options) && this.options.length === 0) {
        this.setInitialChoice();
      }
      this.choice.setChoices(options, 'value', 'label', true);

      if (this.value) {
        this.choice.setChoiceByValue(this.value);
      }
    }
  },

  destroyed() {
    this.choice.passedElement.element.removeEventListener('change', this.handleEvents);
    this.choice.passedElement.element.removeEventListener('search', this.handleSearch);
    this.choice.destroy();
  }
};
